import React from 'react'
import { format, parse, addDays } from 'date-fns'

export const formatDate = (
  dateStr: string | null,
  dateFormat = 'MM/dd/yyyy'
) => {
  let formatedDate = ''
  try {
    if (dateStr) {
      formatedDate = format(parse(dateStr, 'yyyyMMdd', new Date()), dateFormat)
    }
  } catch (err) {
    formatedDate = ''
  }

  return formatedDate
}

export const addFormattedDays = (
  dateStr: string,
  days: number,
  dateFormat = 'yyyyMMdd'
) => {
  if (dateStr) {
    return format(
      addDays(parse(dateStr, 'yyyyMMdd', new Date()), days),
      dateFormat
    )
  }
  return ''
}

const now = Date.now()
export const defaultToday = format(now, 'yyyyMMdd')
export const defaultTomorrow = format(addDays(now, 1), 'yyyyMMdd')
export const defaultMaxDate = format(addDays(now, 330), 'yyyyMMdd')

// Shared methods for Flights, SOPQ Flights and RC
/**
 * @param {object} param0
 * @param {string | null} [param0.departureDate]
 * @param {string | null} [param0.arrivalDate] - The name of the employee.
 * @param {boolean} isOneWay
 */
export const getDateRange = (
  {
    departureDate = null,
    arrivalDate = null
  }: { departureDate: string | null; arrivalDate: string | null },
  isOneWay: boolean
) => {
  if (!departureDate) return ''
  const start = formatDate(departureDate)
  if (isOneWay) return start
  const end = formatDate(arrivalDate)
  return `${start} – ${end}`
}

export const getPackagesDateRange = ({
  startDate,
  endDate
}: {
  startDate: string | null
  endDate: string | null
}) => {
  if (!startDate) return ''
  return `${formatDate(startDate)} - ${formatDate(endDate)}`
}

export const getHotelDateRange = ({
  startDate,
  endDate
}: {
  startDate: string | null
  endDate: string | null
}) => {
  if (!startDate && !endDate) return ''
  const start = formatDate(startDate)
  const end = formatDate(endDate)
  return [start, end].join(' – ')
}

export const getRcMinDate = (pickupDate?: string) => {
  if (pickupDate) {
    return formatDate(pickupDate, 'yyyyMMdd')
  }
  return format(new Date(), 'yyyyMMdd')
}

export const getRcMaxDate = (dropoffDate?: string) => {
  if (dropoffDate) {
    return formatDate(dropoffDate, 'yyyyMMdd')
  }
  return format(addDays(new Date(), 330), 'yyyyMMdd')
}

export const getTimeOptions = () => {
  const times = []
  const minutes = ['00', '30']

  for (let i = 0; i < 48; i += 1) {
    times.push(i)
  }
  const timeOptions = times.map(time => {
    const h = Math.floor(time / 2)
    if (time === 0) {
      return { label: 'Midnight', value: `${h.toString().padStart(2, '0')}:00` }
    }
    if (time === 24)
      return { label: 'Noon', value: `${h.toString().padStart(2, '0')}:00` }
    const hour = h === 0 || h === 12 ? 12 : h % 12
    const minute = minutes[time % 2]
    const meridiem = h < 12 ? 'AM' : 'PM'
    const value = `${h.toString().padStart(2, '0')}:${minute}`
    return {
      key: value,
      label: `${hour}:${minute} ${meridiem}`,
      value
    }
  })
  return timeOptions.map(time => {
    const MIDNIGHT = 'Midnight'
    const NOON = 'Noon'
    const isMidnight = time.value === '00:00'
    const isNoon = time.value === '12:00'
    const parseTime = () =>
      parseInt(time.value, 10) < 12 ? `${time.value} AM` : `${time.value} PM`
    const ifNotMidnight = isNoon ? NOON : parseTime()
    const optionTimeValue = isMidnight ? MIDNIGHT : ifNotMidnight
    return (
      <option key={time.value} {...time}>
        {optionTimeValue}
      </option>
    )
  })
}
